import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  usuarios: [],
  token: null,
  user: null,
  userLoading: false
}

const getters = {
  usuarios: state => state.usuarios,
  usuariosAtivo: state => state.usuarios.filter(u => u.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  token: state => state.token,
  user: state => state.user,
  authenticated: state => !!state.token,
  userLoading: state => state.userLoading,
  isAdmin: state => {
    if (!state.user) {
      return false;
    } else if (state.user.IdUsuario == 4) {
      return true;
    } else if (state.user.IdUsuario == 18) {
      return true;
    } else {
      return false;
    }
  }
}

const actions = {
  login({ commit }, args) {
    return new Promise((resolve, reject) => {
      commit('userLoading', true);
        fetch(`${baseUrl}/sessions`, {
          method: 'post',
          body: JSON.stringify(args),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            const token = data.token;
            const user = data.user;
            commit('setToken', token);
            commit('setUser', user);
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            axios.defaults.headers.common['Authorization'] = token;
            commit('userLoading', false);
            resolve(data);
          } else {
            commit('userLoading', false);
            commit('setUser', null)
            commit('setToken', null)
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            reject(data);
          }
        });
    })
  },
  loginAxios({ commit }, args) {
    return new Promise((resolve, reject) => {
      commit('userLoading', true);
      axios
        .post(`${baseUrl}/sessions`, args, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(response => {
          console.log(response);
          const token = response.data.token;
          const user = response.data.user;
          commit('setToken', token);
          commit('setUser', user);
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          axios.defaults.headers.common['Authorization'] = token;
          commit('userLoading', false);
          resolve(response);
        })
        .catch(error => {
          commit('userLoading', false);
          commit('setUser', null)
          commit('setToken', null)
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          reject(error);
        })
    })
  },
  async loginAsync({ commit }, args) {
    commit('userLoading', true);
    try {
      const response = await axios.post(`${baseUrl}/sessions`, args);
      if (response.data) {
        commit('userLoading', false);
        commit('setToken', response.data.token);
        localStorage.setItem('token', response.data.token);
        commit('setUser', response.data.user);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        axios.defaults.headers.common['Authorization'] = response.data.token;
        return response;
      }
    } catch (error) {
      commit('userLoading', false);
      commit('setUser', null)
      commit('setToken', null)
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      return error;
    }
  },
  logout({ commit }) {
    commit('logout');
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    delete axios.defaults.headers.common['Authorization'];
    return true;
  },
  async fetchUsuarios({ commit }) {
    try {
      const response = await axios.get(`${baseUrl}/usuarios`);
      if (response.data.length) {
        commit('setUsuarios', response.data);
      }
    } catch (error) {
      commit('setUsuarios', []);
    }
  },
  async fetchUsuarioPorId({ commit }, id) {
    try {
      const response = await axios.get(`${baseUrl}/usuarios/${id}`);
      if (response.data.length) {
        return response.data
      }
    } catch (error) {
      console.log(error);
    }
  },
  async fetchUsuariosSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/usuarios?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setUsuarios', response.data);
      } else {
        commit('setUsuarios', []);
      }
    } catch (error) {
      commit('setUsuarios', []);
    }
  },
  async addUsuario({ commit }, usuario) {
    const response = await axios.post(`${baseUrl}/usuarios`, usuario, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    usuario.IdUsuario = response.data.IdUsuario;
    commit('newUsuario', usuario);
    return response.data.IdUsuario;
  },
  async updateUsuario({ commit }, updUsuario) {
    await axios.put(`${baseUrl}/usuarios`, updUsuario, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateUsuario', updUsuario);
  },
  async deleteUsuario({ commit }, id) {
    await axios.delete(`${baseUrl}/usuarios/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeUsuario', id);
  },
  async setaSenhaUsuario({ commit }, usuario) {
    await axios.patch(`${baseUrl}/usuarios`, usuario, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    return true;
  },
  async atualizaSenhaUsuario({ commit }, obj) {
    return await axios.post(`${baseUrl}/sessions/atualizasenha`, obj);
  },
  setToken({ commit }, token) {
    commit('setToken', token);
  },
  setUser({ commit }, user) {
    commit('setUser', user);
  }
}

const mutations = {
  setUsuarios: (state, usuarios) => state.usuarios = usuarios,
  setToken: (state, token) => state.token = token,
  setUser: (state, user) => state.user = user,
  logout: state => {
    state.token = '';
    state.user = null;
  },
  userLoading: (state, status) => state.userLoading = status,
  // CRUD
  newUsuario: (state, usuario) => state.usuarios.push(usuario),
  removeUsuario: (state, id) => state.usuarios = state.usuarios.filter(usuario => usuario.IdUsuario !== id),
  updateUsuario: (state, updUsuario) => {
    const index = state.usuarios.findIndex(usuario => usuario.IdUsuario === updUsuario.IdUsuario);
    if (index !== -1) {
      state.usuarios.splice(index, 1, updUsuario);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}